import { useSharedSessionKeeper } from '../hooks/useSharedSession';

/** Renders nothing. Mounted once at the app root, so every page keeps a shared session going (ACT2-879). */
export function SharedSessionKeeper(): null {
  useSharedSessionKeeper();
  return null;
}
